import React from 'react'
import styled from 'styled-components'
import { rem, transitions } from 'polished'

import theme from 'styles/theme'
import { Title32 } from 'components/Typography'

export const Section = styled.section`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
`

export const SectionHeader = styled((props) => <Title32 {...props} as="h2" />)`
  width: 100%;
  text-align: center;
  font-size: ${rem(30)};
  padding: 0px 20px;

  ${theme.mediaQueries.medium} {
    font-size: ${rem(48)};
    font-weight: 300;
  }
`

export const CarouselContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  column-gap: 14px;
  overflow: visible;
  width: 100%;
  padding: 0px 20px;

  .slick-slide {
    min-height: initial;
    height: initial;
    display: flex;
    width: 71.8vw;

    > * {
      flex: 1;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;

      > * {
        height: 100%;
      }
    }

    ${theme.mediaQueries.medium} {
      margin-left: 14px;
      width: ${rem(289)} !important;
    }
  }

  .slick-initialized .slick-slide {
    display: flex;
  }

  .slick-track {
    display: flex;
    flex-flow: row nowrap;
    align-items: stretch;
    column-gap: 12px;

    ${(props) =>
      props.centralized &&
      `
      margin: 0 auto;
      justify-content: center;
    `}
  }

  .slick-list {
    max-width: 1023px;
    margin: 0 auto;
    overflow: visible;
  }

  ${theme.mediaQueries.medium} {
    padding: 14px;

    .slick-list {
      padding: 12px;
    }
  }
`

export const VerticalContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  row-gap: ${rem(38.51)};
  padding: 0px ${rem(20)};
`

export const DotsContainer = styled.ul`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  width: 100%;
  column-gap: 8px;
  padding: initial;
  padding-top: 12px;

  & li::marker {
    display: none;
    opacity: 0;
    font-size: 0;
  }

  .slick-active *::after {
    background-color: ${theme.colors.carouselActiveDot};
  }

  ${theme.mediaQueries.medium} {
    flex-flow: row nowrap;
  }
`

export const CarouselDot = styled.div`
  cursor: pointer;
  width: 100%;
  position: relative;
  padding: 12px 0px;
  background-color: transparent;

  &:hover {
    &::after {
      height: 4px;
      top: calc(50% - 2px);
    }
  }

  &::after {
    ${transitions('background-color 0.5s, height 0.3s, top 0.3s')}
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    width: 100%;
    height: 1px;
    background-color: ${theme.colors.carouselDot};
  }

  ${theme.mediaQueries.medium} {
    width: 285px;
  }
`

export const DotsCounter = styled.span`
  width: 100%;
  text-align: center;
  font-family: BrownStd-Light, sans-serif;
`

export const DotsWrapper = styled.div`
  width: calc(100% - 40px);
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  column-gap: 12px;
  padding-top: ${rem(16)};

  li {
    width: ${(props) => 100 / props.totalCount}%;
  }
`
